"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.MostCommonQuestions = void 0;
var _api = require("../../api");
var _constants = require("../../constants");
var _hooks = require("../../hooks");
var _QuestionList = require("../QuestionList/QuestionList");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const MostCommonQuestions = ()=>{
    const { translations } = (0, _hooks.useTranslations)();
    const { data, loading } = (0, _api.useMostCommonQuestions)();
    if (loading || (data === null || data === void 0 ? void 0 : data.questions.length) == null || data.questions.length < 1) {
        return null;
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_styles.Root, {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_styles.Inner, {
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)(_styles.Title, {
                    children: translations.mostCommonQuestions
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)(_QuestionList.QuestionList, {
                    questionList: data.questions,
                    isShowMoreEnabled: false,
                    truncate: _constants.MOST_COMMON_ITEM_MAX_AMOUNT_LINES
                })
            ]
        })
    });
};
exports.MostCommonQuestions = MostCommonQuestions;
